import React, { FC, useState, useEffect } from 'react';

import cx from 'classnames';

import LandingTabSkeleton from 'blocks/LandingTabSkeleton';

import { LandingMenuSnippetPages } from 'lib/sanity/types';

import { RouteBasePaths } from 'constants/values';

export type LandingTabMenuProps = {
  landingMenuSnippetPages: LandingMenuSnippetPages;
  isFromCaseStudy?: boolean;
  selectedIndexFromLandingPage?: number;
};

const LandingTabMenuSkeleton: FC<LandingTabMenuProps> = ({
  landingMenuSnippetPages,
  isFromCaseStudy,
  selectedIndexFromLandingPage,
}) => {
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  useEffect(() => {
    if (isFromCaseStudy) {
      setSelectedIndex(
        landingMenuSnippetPages.findIndex(
          (landingMenuSnippetPage) =>
            landingMenuSnippetPage.slug === RouteBasePaths.WORK,
        ),
      );
    }
  }, []);

  return (
    <div className="LandingTabMenu flex flex-col h-screen max-h-screen">
      {landingMenuSnippetPages.map((landingMenuSnippetPage, index) => (
        <LandingTabSkeleton
          key={landingMenuSnippetPage._id}
          landingMenuSnippetPage={landingMenuSnippetPage}
          selectedIndex={
            selectedIndexFromLandingPage != null
              ? selectedIndexFromLandingPage
              : selectedIndex
          }
          index={index}
          isFromCaseStudy={isFromCaseStudy}
        />
      ))}
    </div>
  );
};

export default LandingTabMenuSkeleton;
